import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { Swiper } from 'swiper/types';
import { PersonalizeStore, usePersonalizeStore } from '@/stores/personalize-store';

export const usePersonalize = () => {
  const personalizeStore: PersonalizeStore = usePersonalizeStore();

  const { personalizeForm } = storeToRefs(personalizeStore);

  const loading = ref(false);
  const swiperPersonalize = ref<Swiper>();

  return { personalizeForm, loading, swiperPersonalize, resetStore: personalizeStore.resetStore };
};
